module.exports = __webpack_public_path__ + "img/yktlogo.97789bc2.png";